import { gql } from "apollo-boost"

export const getBudgetData = gql`
  query BudgetLight($id: ID!) {
    BudgetLight(id: $id) {
      concepts {
        id
        isBlocking
        name
        index
        region
        type
        measurementUnit
        unitCost
        totalUnits
        monthlyDistribution
        monthlyDistributionHours
        budgeted
        hours
        investmentDistribution {
          id
          name
          type
          percentage
        }
      }
    }
  }
`